/**
 * Лента событий игрока: GET /feed, POST /feed/mark-read (§Т2.11).
 */

import { apiFetch } from "./client.js";

export type FeedEventView = {
  readonly id: number;
  readonly kind: string;
  readonly params: Record<string, unknown>;
  readonly hexId: string | null;
  readonly createdAt: string;
  readonly read: boolean;
};

export type FeedListView = {
  readonly events: readonly FeedEventView[];
  readonly unreadCount: number;
};

export async function fetchFeed(
  token: string,
  signal?: AbortSignal,
): Promise<FeedListView> {
  return apiFetch<FeedListView>("/feed", {
    token,
    ...(signal ? { signal } : {}),
  });
}

export async function markFeedRead(
  token: string,
  body: { readonly ids?: readonly number[]; readonly all?: boolean },
): Promise<{ marked: number }> {
  return apiFetch<{ marked: number }>("/feed/mark-read", {
    method: "POST",
    token,
    body: JSON.stringify(body),
  });
}
